import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.reflect.delete-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      modalIndex: 9,
      visible: false,
      noBefore: false,
      loading: false,
      component: 'div',
      title: '',
      noFooter: false,
      noConfirmBtn: false,
      compProps: {},
      modalProps: {
        modalAppendToBody: true,
        // 放在body下
        lockScroll: true,
        appendToBody: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        width: '900px',
        // 需要带单位
        cancelText: '',
        okText: '确定'
      },
      disabledSubmitBtn: false,
      // 是否禁用提交按钮
      defer: {} // 用来保存promise状态，等待触发

    };
  },
  methods: {
    show: function show(Component, compProps, modalProps) {
      var _this = this;

      this.component = Component;
      this.modalIndex = modalProps.modalIndex;
      var _parent = compProps.parent;
      Reflect.deleteProperty(compProps, 'parent');
      _parent && this.setWatchers(_parent, compProps);
      this.compProps = _objectSpread(_objectSpread({}, compProps), {}, {
        close: function close(res) {
          return _this.close(res);
        },
        'toggleDisable': this.toggleDisable
      });
      this.title = modalProps.title;
      this.noFooter = modalProps.noFooter || false;
      this.noConfirmBtn = modalProps.noConfirmBtn || false;
      Reflect.deleteProperty(modalProps, 'modalIndex');
      Reflect.deleteProperty(modalProps, 'title');
      Reflect.deleteProperty(modalProps, 'noFooter');
      this.modalProps = _objectSpread(_objectSpread({}, this.modalProps), modalProps);
      this.visible = true;
      return new Promise(function (resolve, reject) {
        _this.defer = {
          resolve: resolve,
          reject: reject
        };
      });
    },
    toggleDisable: function toggleDisable(state) {
      this.disabledSubmitBtn = state;
    },
    setWatchers: function setWatchers(parent, comProps) {
      var _this2 = this;

      Object.keys(comProps).forEach(function (key) {
        parent.$watch(key, function (_new) {
          _this2.$set(_this2.compProps, key, _new);
        });
      });
    },
    onCancel: function onCancel(type) {
      var _this3 = this;

      if (!this.$refs.comp.onCancel) {
        this.close(false);
        return;
      }

      this.$refs.comp.onCancel(function (res) {
        return _this3.close(res);
      }, type);
    },
    onOk: function onOk() {
      var _this4 = this;

      if (!this.$refs.comp.onOk) {
        this.visible = false;
        this.close(true);
        return;
      }

      this.$refs.comp.onOk(function (res) {
        return _this4.close(res);
      });
    },
    close: function close(res) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                window.modals.pop();
                !_this5.noBefore && window.modals[window.modals.length - 1] && window.modals[window.modals.length - 1].setVisible(true);
                _this5.visible = false;

                _this5.removeCurDom();

                _this5.defer.resolve(res);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    removeCurDom: function removeCurDom() {
      var dialogEl = document.getElementById(this.modalIndex + '_modal_id');
      dialogEl && document.body.removeChild(dialogEl);
    },
    setVisible: function setVisible(v) {
      this.visible = v;
    },
    // noBefore 关闭当前的，不显示之前的弹窗，路由变化的时候用
    closeAll: function closeAll() {
      var noBefore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.noBefore = noBefore;
      this.close(false);
    }
  }
};